import { appUrl } from "@astro/config"

const ICONS = {
  trend: 'M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941',
  heart: 'M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z',
  archive:
    'M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z',
  currency:
    'M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  star: 'M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.563.563 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z',
  calendar:
    'M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5',
  users:
    'M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z',
  briefcase:
    'M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z',
  globe:
    'M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418',
  sparkle:
    'M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456Z',
  bolt: 'M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z',
  settings:
    'M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z',
  clock: 'M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  refresh:
    'M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99',
  shieldCheck:
    'M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z',
}

export const HERO_SLIDES = [
  {
    badgeIcon: 'ॐ',
    badgeLabel: 'Vedic Jyotish',
    headingTop: 'KNOW YOUR',
    headingBottom: 'TRUE FUTURE',
    copy: 'Get clear answers about your career, health, marriage, and money through trusted Vedic astrology — by Astrologer Raju Maharaj Ji.',
    cards: [
      { title: 'Career & Job', subtitle: 'Growth & Success', icon: ICONS.trend },
      { title: 'Health', subtitle: 'Mind & Body', icon: ICONS.heart },
      { title: 'Marriage', subtitle: 'Match Making', icon: ICONS.archive },
      { title: 'Money & Wealth', subtitle: 'Luck & Money', icon: ICONS.currency },
    ],
    primaryCta: {
      label: 'Book Consultation',
      internal: false,
      to: appUrl("jyotish", "book-maharaj-ji")
    },
    secondaryCta: {
      label: 'Meet The Maharaj Ji',
      internal: false,
      to: appUrl("jyotish", "maharaj-ji")
    },
    isMainSlide: true,
  },
  {
    badgeIcon: '💍',
    badgeLabel: 'Vivah Jyotish',
    headingTop: 'FIND YOUR',
    headingBottom: 'TRUE SOULMATE',
    copy: 'Discover celestial compatibility through ancient Kundali matching and Vivah muhurat — unlock the cosmic blueprint of your sacred union.',
    cards: [
      { title: 'Kundali Match', subtitle: 'Compatibility', icon: ICONS.star },
      { title: 'Vivah Muhurat', subtitle: 'Auspicious Date', icon: ICONS.calendar },
      { title: 'Love Life', subtitle: 'Relationship Remedy', icon: ICONS.heart },
      { title: 'Family Harmony', subtitle: 'Grih Shanti', icon: ICONS.users },
    ],
    primaryCta: {
      label: 'Match Kundali',
      internal: true,
      to: "/astro-tools"
    },
    secondaryCta: {
      label: 'Learn More',
      internal: true,
      to: "/horoscope"
    },
  },
  {
    badgeIcon: '💼',
    badgeLabel: 'Karma Jyotish',
    headingTop: 'UNLOCK YOUR',
    headingBottom: 'CAREER PATH',
    copy: 'Reveal planetary strengths for business, promotion, and foreign success — perfectly aligned with your natal chart by Maharaj Ji.',
    cards: [
      { title: 'Job & Promotion', subtitle: 'Career Boost', icon: ICONS.briefcase },
      { title: 'Business Growth', subtitle: 'Entrepreneur', icon: ICONS.trend },
      { title: 'Foreign Abroad', subtitle: 'Travel Yoga', icon: ICONS.globe },
      { title: 'Skills & Talent', subtitle: 'Hidden Gifts', icon: ICONS.sparkle },
    ],
    primaryCta: {
      label: 'Career Reading',
      internal: true,
      to: "/blog"
    },
    secondaryCta: {
      label: 'Explore Service',
      internal: false,
      to: appUrl("jyotish")
    },
  },
  {
    badgeIcon: '🌿',
    badgeLabel: 'Arogya Jyotish',
    headingTop: 'HEAL YOUR',
    headingBottom: 'MIND & BODY',
    copy: 'Ancient Vedic prescriptions to restore vitality, mental peace, and longevity — personalised planet-aligned remedies by Maharaj Ji.',
    cards: [
      { title: 'Physical Health', subtitle: 'Vitality & Strength', icon: ICONS.bolt },
      { title: 'Mental Peace', subtitle: 'Inner Calm', icon: ICONS.settings },
      { title: 'Longevity', subtitle: 'Ayur Yoga', icon: ICONS.clock },
      { title: 'Dasha Remedy', subtitle: 'Planetary Fix', icon: ICONS.refresh },
    ],
    primaryCta: {
      label: 'Health Reading',
      internal: true,
      to: "/blog"
    },
    secondaryCta: {
      label: 'Book Session',
      internal: false,
      to: appUrl("jyotish", "consultations")
    },
  },
  {
    badgeIcon: '💰',
    badgeLabel: 'Dhana Jyotish',
    headingTop: 'ATTRACT YOUR',
    headingBottom: 'TRUE WEALTH',
    copy: 'Align your financial destiny with Vedic wealth remedies — unlock money flow, investment timing, and abundance through the stars.',
    cards: [
      { title: 'Money Flow', subtitle: 'Income & Gains', icon: ICONS.currency },
      { title: 'Investment Time', subtitle: 'Best Muhurat', icon: ICONS.trend },
      { title: 'Debt Relief', subtitle: 'Financial Remedy', icon: ICONS.shieldCheck },
      { title: 'Prosperity Yantra', subtitle: 'Sacred Tools', icon: ICONS.sparkle },
    ],
    primaryCta: {
      label: 'Wealth Reading',
      internal: true,
      to: "/blog"
    },
    secondaryCta: {
      label: 'Book Consultation',
      internal: false,
      to: appUrl("jyotish", "consultations")
    },
  },
]
